import { Link } from "react-router-dom";
import { FaHome } from "react-icons/fa";
import {
  FaCartShopping,
  FaChartLine,
  FaNewspaper,
  FaUsers,
} from "react-icons/fa6";
import { RootState } from "../redux/Store";
import { useSelector } from "react-redux";

const BottomNavbar = ({ current }: { current: string }) => {
  const State = useSelector((state: RootState) => state);
  const favouriteFoods = State.FavouriteFood.quoteItems;

  return (
    <div className="fixed lg:hidden bottom-0 left-0 right-0 bg-white shadow-gray-400 shadow-2xl z-50">
      <div className="flex justify-around py-2">
        <Link
          to="/"
          className={`flex flex-col items-center px-3 py-1 ${
            current === "home" ? "text-primary" : "text-gray-400"
          }`}
        >
          <FaHome className="text-lg" />
          <span className="text-xs mt-1">Home</span>
        </Link>
        <Link
          to="/products"
          className={`flex flex-col items-center px-3 py-1 ${
            current === "products" ? "text-primary" : "text-gray-400"
          }`}
        >
          <FaChartLine className="text-lg" />
          <span className="text-xs mt-1">Products</span>
        </Link>

        <Link
          to="/blog"
          className={`flex flex-col items-center px-3 py-1 ${
            current === "blog" ? "text-primary" : "text-gray-400"
          }`}
        >
          <FaNewspaper className="text-lg" />
          <span className="text-xs mt-1">Blog</span>
        </Link>

        <Link
          to={"/cart"}
          className={`flex flex-col items-center px-3 py-1 ${
            current === "cart" ? "text-primary" : "text-gray-400"
          }`}
        >
          <FaCartShopping className="text-lg" />
          <span className="text-xs mt-1 flex gap-1">
            Cart{" "}
            {favouriteFoods.length > 0 && (
              <span className="bg-primary text-white w-5 h-5 mt-[-4vh] flex items-center justify-center rounded-full text-xs">
                {favouriteFoods?.length}
              </span>
            )}
          </span>
        </Link>
        <Link
          to="/about"
          className={`flex flex-col items-center px-3 py-1 ${
            current === "about" ? "text-primary" : "text-gray-400"
          }`}
        >
          <FaUsers className="text-lg" />
          <span className="text-xs mt-1">About</span>
        </Link>
      </div>
    </div>
  );
};

export default BottomNavbar;
